import { ProductResponse } from 'lib/services/models/content-response';
import useDictionary from 'lib/hooks/useDictionary';

import styles from './ProductIngredients.module.scss';

export interface ProductIngredientsProps {
  product?: ProductResponse;
}

export function ProductIngredients({ product }: ProductIngredientsProps) {
  const { getDictionaryValue } = useDictionary();

  const ingredientDeclaration = product?.IngredientDeclaration;

  const ingredientsHeadline =
    getDictionaryValue('Components.Product.ProductIngredients.ProductIngredientsHeadline') ||
    'Ingredients';
  const ingredientDeclarationFallback =
    getDictionaryValue(
      'Components.Product.ProductIngredients.ProductIngredientDeclarationFallback'
    ) || 'Information not available';
  return (
    <div className={styles.productIngredientsContainer}>
      <h2 className={styles.productIngredientsHeading}>{ingredientsHeadline}</h2>
      <p className={styles.productIngredientsText}>
        {ingredientDeclaration || ingredientDeclarationFallback}
      </p>
    </div>
  );
}
